import React from 'react'
import { Flex } from 'theme-ui'
import { Button, Svg } from 'ui'
import ConfirmEmailIcon from 'images/organization/confirm-email-icon.svg'
import ConfirmEmailDarkMobileIcon from 'images/organization/confirm-email-mobile-icon.svg'
import ConfirmEmailLightMobileIcon from 'images/organization/confirm-email-mobile-light-icon.svg'
import Overlay from 'ui/Overlay'
import { navigate } from 'gatsby'
import useGetUser from 'components/Dashboard/utils/useGetUser'
import useBreakpointIndex from 'ui/Theme/useBreakpointIndex'
import useGetColorMode from 'utils/useGetColorMode'
import TextWithOverFlowAndTippyPopup from 'components/TextWithOverFlowAndTippyPopup'
import { TextWithBreakpointVariant } from 'ui/TextWithBreakpointVariant'

export default function ConfirmEmailScreen(): React.ReactElement {
  const { data: userData } = useGetUser()
  const signUpEmailAddress = userData?.email
  const isMobile = useBreakpointIndex() === 0
  const { isLightMode } = useGetColorMode()

  return (
    <Overlay
      sx={{
        pt: '10rem',
        alignItems: 'unset',
      }}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          textAlign: 'center',
          alignItems: 'center',
          px: '1.6rem',
        }}
      >
        <TextWithBreakpointVariant
          variant={['size28Weight600', 'size48Weight600']}
          sx={{
            mb: ['4.8rem', '8rem'],
            color: 'aliceBlue',
          }}
        >
          Confirm your email.
        </TextWithBreakpointVariant>
        <Svg
          svg={
            isMobile
              ? isLightMode
                ? ConfirmEmailLightMobileIcon
                : ConfirmEmailDarkMobileIcon
              : ConfirmEmailIcon
          }
          descriptiveText="Email confirmation illustration"
        />
        <TextWithBreakpointVariant
          variant={['size16Weight400Line140', 'size18Weight400Line140']}
          sx={{
            display: 'inline-flex',
            flexDirection: 'column',
            maxWidth: ['100%', '60rem'],
            mt: '2.4rem',
            color: 'aliceBlue',
            mb: '4.8rem',
          }}
        >
          To finish up, please confirm your email{' '}
          <TextWithOverFlowAndTippyPopup
            ariaLabel="sign up email address"
            variant={['size16Weight600Line140', 'size18Weight600Line140']}
            sxText={{ color: 'greenApple' }}
            content={signUpEmailAddress}
          />{' '}
          to get access to your dashboard.
        </TextWithBreakpointVariant>
        <Button
          ariaLabel="change email"
          variant="newTertiary"
          sx={{
            width: ['13.8rem', '19.8rem'],
            height: '4.8rem',
            borderRadius: '10rem',
          }}
          onClick={() => navigate('/dashboard/account')}
        >
          Change Email
        </Button>
      </Flex>
    </Overlay>
  )
}
